import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {speakerValidationGuard} from "@/core/security/speaker-validation.guard";

export const admin: Routes = [
  {
    path:'',
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./base/dashboard.component')
            .then((m) => m.DashboardComponent),
        title: 'FusionLex Behavioral Intelligence'
      },
      {
        path: 'insights',
        loadComponent: () =>
            import('./pages/insights/insights.component')
                .then((m) => m.InsightsComponent),
        title: 'All Insights',
        canActivate: [speakerValidationGuard]
      },
      {
        path: 'billing',
        loadComponent: () =>
            import('./pages/billing/billing.component')
                .then((m) => m.BillingComponent),
        title: 'Billing',
      },
      {
        path: 'about-fusionlex',
        loadComponent: () =>
            import('./pages/about-me/about-me.component')
                .then((m) => m.AboutMeComponent),
        title: 'fusion-lex-and-founder',
      },
      /**{
        path: 'analysis-hub/behavioral-state-space',
        loadComponent: () =>
            import('./pages/behavioral-state-space/behavioral-state-space.component')
                .then((m) => m.BehavioralStateSpaceComponent),
        title: 'Behavioral State Space'
      },*/
      {
        path: 'analysis-hub/engagement-dynamics',
        loadComponent: () =>
            import('./pages/engagement-dynamics/engagement-dynamics.component')
                .then((m) => m.EngagementDynamicsComponent),
        title: 'Engagement Dynamics',
        canActivate: [speakerValidationGuard]
      },
      {
        path: 'analysis-hub/alignment-relationship',
        loadComponent: () =>
            import('./pages/alignment-relationship/alignment-relationship.component')
                .then((m) => m.AlignmentRelationshipComponent),
        title: 'Alignment & Relationship',
        canActivate: [speakerValidationGuard]
      },
      {
        path: 'analysis-hub/breakdowns-risks',
        loadComponent: () =>
            import('./pages/risks/risks.component')
                .then((m) => m.RisksComponent),
        title: 'Breakdown & Risks',
        canActivate: [speakerValidationGuard]
      },
      {
        path: 'conversations',
        children: [
          {
            path: 'upload-conversation',
            loadComponent: () =>
                import('./pages/upload-conversation/upload-conversation.component')
                    .then(m => m.UploadConversationComponent),
            canActivate: [speakerValidationGuard]
          },
          {
            path: 'all-analyses',
            loadComponent: () =>
                import('./pages/all-conversation-analysis/all-conversation-analysis.component')
                    .then(m => m.AllConversationAnalysisComponent),
            canActivate: [speakerValidationGuard]

          }
        ]
      }

    ]
  }];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class dashboardRoutingModule {
  static routes = admin;
}
